<script lang="ts" setup>
/**
 * A reusable header component for GSheet dialogs and popovers.
 * Includes optional back button, centered title, and close button.
 */
withDefaults(defineProps<{
  hasTitle?: boolean
  hideCloseButton?: boolean
  disableClose?: boolean
  showBackButton?: boolean
}>(), { hasTitle: false,hideCloseButton: false,disableClose: false,showBackButton: false, })

defineEmits<{
  close: []
  back: []
}>()
</script>

<template>
  <div
    class="g-sheet-header relative w-full flex items-center justify-center"
    :class="hasTitle ? 'p-5' : 'py-0'"
  >
    <!-- Back Button (absolute left) -->
    <GSheetButtonBack
      v-if="showBackButton"
      :disabled="disableClose"
      class="absolute left-5 top-5 z-dialog-button"
      @click="$emit('back')"
    />

    <!-- Center: Title -->
    <div
      v-if="hasTitle"
      class="g-sheet-header-title font-semibold text-lg lg:text-xl text-center text-balance w-full"
      :class="[
        'pl-10',
        !hideCloseButton ? 'pr-10' : '',
      ]"
    >
      <slot/>
    </div>

    <!-- Close Button (absolute right) -->
    <GSheetButtonClose
      v-if="!hideCloseButton"
      :disabled="disableClose"
      class="absolute right-5 top-4 z-dialog-button"
      @click="$emit('close')"
    />
  </div>
</template>
